<template>
  <v-app>
  <v-toolbar class="white">
  	<img alt="Vue logo" src="./assets/rexel_logo_mini.jpg">
    <v-toolbar-title class="indigo--text text--darken-2">AANVRAAGFORMULIER OFFERTE VENTILATIESYSTEEM</v-toolbar-title>
      <v-toolbar-items>
        <v-btn flat dark>Vue</v-btn>
        <v-btn flat dark>Vuex</v-btn>
        <v-btn flat dark>Nuxt</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-content>
      <Formulaire/>
    </v-content>
  </v-app>
</template>

<script>
import Formulaire from './components/Formulaire'

export default {
  name: 'App',
  components: {
    Formulaire
  },
  data () {
    return {
      //
    }
  }
}
</script>
